export const validateUrl = (redirectUrl: string): boolean => {
  const validUrlPattern = /^(\/[^\s]*)$|^(https:\/\/(www\.)?example\.com[^\s]*)$/;
  return validUrlPattern.test(redirectUrl);
};
